<template>
  <main class="login-page">
    <div class="login-card">
      <Spinner />
      <p class="mt-4 text-muted-foreground">{{ statusMessage }}</p>
    </div>
  </main>
</template>

<script setup lang="ts">
import { Spinner } from '@/components/ui/spinner';

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useMainStore } from '../store';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();
const store = useMainStore();

const statusMessage = ref('Завершение входа через SSO...');

onMounted(async () => {
  const code = route.query.code as string;
  if (!code) {
    await router.replace({ name: 'login', query: { error: 'oidc' } });
    return;
  }

  try {
    const res = (await axios.post('/api/auth/oidc/exchange/', { code })).data;
    store.login({ access: res.access, refresh: res.refresh });
    await store.setCurrentUserName(res.username);

    const next = route.query.next as string;
    if (next) {
      await router.replace(next);
    } else {
      await router.replace('/');
    }
  } catch {
    statusMessage.value = 'Не удалось завершить вход';
    await router.replace({ name: 'login', query: { error: 'oidc' } });
  }
});
</script>
